import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCustomersByErpCustomerId = (
    token: string,
    backend: string,
    erpprojectid: any
) => {
    return fetch(
        `${getApiUrl(backend)}customers/by_erpcustomerid/${erpprojectid}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getCustomersByErpCustomerId;